<template>
  <div>
    物资调配
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
